import { useTheme } from '../context/ThemeContext';

/**
 * Blog cover photo. Each cover ships in two WebP sizes (480w / 960w) and the
 * browser picks the smaller one for cards. Lazy-loaded by default so covers
 * below the fold never delay the page; pass `eager` for the post header.
 */
export default function BlogCover({ cover, height, sizes = '(max-width: 600px) 100vw, 480px', eager = false }) {
  const { colors } = useTheme();
  return (
    <img
      src={cover.small}
      srcSet={`${cover.small} 480w, ${cover.large} 960w`}
      sizes={sizes}
      alt={cover.alt}
      width="960"
      height="540"
      loading={eager ? 'eager' : 'lazy'}
      decoding="async"
      fetchpriority={eager ? 'high' : undefined}
      style={{
        display: 'block', width: '100%', height, objectFit: 'cover',
        background: colors.surface2, // placeholder tone while the photo loads
      }}
    />
  );
}
